declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
  }
}

type EventProps = Record<string, unknown>;

const ATTRIBUTION_KEY = 'cvpro_attribution';
const EVENT_LOG_KEY = 'cvpro_event_log';

const safeWindow = () => (typeof window !== 'undefined' ? window : null);

export const getExperimentVariant = () => {
  const win = safeWindow();
  if (!win) return 'control';

  const params = new URLSearchParams(win.location.search);
  return params.get('variant') || 'control';
};

export const captureAttribution = () => {
  const win = safeWindow();
  if (!win) return null;

  const params = new URLSearchParams(win.location.search);
  const attribution = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_content: params.get('utm_content') || '',
    utm_term: params.get('utm_term') || '',
    variant: getExperimentVariant(),
    landing_path: win.location.pathname,
  };

  const hasAnyAttribution = Object.values(attribution).some(Boolean);
  if (hasAnyAttribution) {
    win.localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(attribution));
  }

  return JSON.parse(win.localStorage.getItem(ATTRIBUTION_KEY) || 'null');
};

export const getStoredAttribution = () => {
  const win = safeWindow();
  if (!win) return null;

  return JSON.parse(win.localStorage.getItem(ATTRIBUTION_KEY) || 'null');
};

export const trackEvent = (event: string, props: EventProps = {}) => {
  const win = safeWindow();
  if (!win) return;

  const payload = {
    event,
    path: win.location.pathname,
    url: win.location.href,
    variant: getExperimentVariant(),
    timestamp: new Date().toISOString(),
    ...getStoredAttribution(),
    ...props,
  };

  try {
    const currentLog = JSON.parse(win.localStorage.getItem(EVENT_LOG_KEY) || '[]');
    const nextLog = [...currentLog, payload].slice(-100);
    win.localStorage.setItem(EVENT_LOG_KEY, JSON.stringify(nextLog));
  } catch (error) {
    console.error('Analytics log error:', error);
  }

  win.dispatchEvent(new CustomEvent('cvpro:track', { detail: payload }));
  win.dataLayer?.push(payload);

  if (typeof win.gtag === 'function') {
    win.gtag('event', event, payload);
  }

  if (typeof win.fbq === 'function') {
    win.fbq('trackCustom', event, payload);
  }
};

export const trackPageView = (pageType: string) => {
  captureAttribution();
  trackEvent('page_view', { page_type: pageType });
};
